<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="case-6">
<h1>Case 6</h1>
<div class="section level21" id="clinical-presentation-5">
<p style="padding-bottom:6px; letter-spacing:1px;padding-top:28px;font-weight:bold;text-indent:0px;">Clinical Presentation</p>
<p style="text-indent:0px;">A 46-year-old woman presented with an abdominal discomfort. An abdominal ultrasound revealed a midline liver with no spleen seen in the left hypochondrium. No significant medical or surgical history.</p>
</div>
<div class="section level21" id="radiological-findings-5">
<p style="padding-bottom:6px; letter-spacing:1px;padding-top:28px;font-weight:bold;text-indent:0px;">Radiological Findings</p>
<p style="text-indent: 0px; text-align: center;"><img alt="6" src="media/6.png"/></p>
<p style="padding-top: 15px;padding-bottom:10px; text-align: center;"></p>
<ul style="list-style:none;padding-right:105px;padding-left:110px;margin-top:0px;"><li>
<p style="text-indent:20px;"><strong>Enhanced abdominal CT scan, axial (A, B, C, D) with coronal reformatted (E, F) images.</strong> The liver is in midline (or bridging liver) with stomach on the right side. Three splenules are seen on the right below the liver (arrows in C and E) with no splenic structure seen in the left hypochondrium. Note an interruption of the inferior vena cava with azygous continuation of the IVC (arrow in A). The head and the corporeo-caudal region of the pancreas are on the right, giving the appearance of a lying V (image C) with Preduodenal position of the portal vein. The duodenojejunal junction does not cross the midline; it should be located on the same side of the body as the stomach and approximately at the level of the duodenal bulb, indicating associated intestinal malrotation.</p>
</li></ul>
<p style="text-indent:0px;padding-top:15px;"><strong>Diagnosis:</strong> Heterotaxy-Polysplenia-Azygous Continuation of IVC</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch012.vue?f6671454